import { Injectable } from '@angular/core';
import {
  AuthorityOwnerModel,
  AuthorityProfileModel,
  PersonProfileModel,
  UserProfileResponseModel,
} from '../../models/user-profile/user-profile.model';
import { Observable } from 'rxjs';
import { EsResponseModel } from '../shared/EsResponseModel';
import { EsBaseTemplateService } from '../shared/es-base-template.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { LookupDto } from '../../models/shared/LookupDto';
import { EsValidateEmiratesIdDto } from '../shared/EsValidateEmiratesIdDto';
import { environment } from 'src/environments/environment';
import { OwnerValidateOTPData, RegistrationModel } from '../../models/user-profile/registration.model';
import { EsOtpDto } from '../shared/EsOtpDto';

@Injectable()
export class RegistrationService extends EsBaseTemplateService {
  protected override BASE_API: string = environment.loginDomainURL;
  protected APIManagerKey: string = environment.loginAPIManagerKey;
  protected APIManagerKeyHeader: string = environment.loginAPIManagerKeyHeader;
  basePath: string = 'account';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public GetPersonToRegister(
    token: string
  ): Observable<UserProfileResponseModel> {
    const url = this.buildUrl(`UserInfo`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .post<UserProfileResponseModel>(url, { UserId: token }, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public GetAuthorityToRegister(
    token: string
  ): Observable<UserProfileResponseModel> {
    const url = this.buildUrl(`CompanyInfo`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .post<UserProfileResponseModel>(url, { UserId: token }, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public Register(model: RegistrationModel) {
    const url = this.buildUrl(`Register`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .post<string>(url, model, {headers: headers})
      .pipe(catchError(this.handleError));
  }

  public GetLicenseIssuers(
    emirateId: number
  ): Observable<LookupDto[]> {
    const url = this.buildUrl(`GetLicenseIssuersByEmirateId?EmirateId=${emirateId}`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .get<LookupDto[]>(url, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public ValidateIdNumber(
    idNumber: string
  ): Observable<EsResponseModel<EsValidateEmiratesIdDto>> {
    const url = this.buildUrl(`ValidateIdNumber?idNumber=${idNumber}`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .get<EsResponseModel<EsValidateEmiratesIdDto>>(url, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public ValidateOTP(
    otpModel:EsOtpDto
  ): Observable<EsResponseModel<OwnerValidateOTPData>> {
    const url = this.buildUrl(`ValidateOtp`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .post<EsResponseModel<OwnerValidateOTPData>>(url,otpModel, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public ValidateAuthorityName(name: string, emirateId: number, lang: string) {
    const url = this.buildUrl(
      `ValidateAuthorityName?name=${name}&emirateId=${emirateId}&lang=${lang}`
    );
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .get<EsResponseModel<boolean>>(url, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public ValidateLicenseNumber(licenseNumber: string, licenseIssuerId: number) {
    const url = this.buildUrl(
      `ValidateAuthorityLicense?licenseNo=${licenseNumber}&licenseIssuerId=${licenseIssuerId}`
    );
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
      .get<boolean>(url, { headers: headers })
      .pipe(catchError(this.handleError));
  }

  public Login(token:any): Observable<void> {
    let url = this.buildUrl(`Login`);
    const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
    return this.httpClient
        .post<void>(url,token, { headers: headers, withCredentials:true })
        .pipe(catchError(this.handleError));
}

  public override buildUrl(endingUri: string): string {
    return `${this.BASE_API}${this.basePath}/${endingUri}`;
  } 
}
